import * as React from 'react';
import Accordion from 'src/app/Container/Accordion/Accordion';
import { ConfigurationHeader, ConfigurationPartProps, ConfigurationPart } from 'src/app/Partials';
import { 
  DrainAccessories,
} from 'src/app/Partials/Configuration/Inputs';

import { connect } from 'react-redux';
import { GlobalPrivateState, formatMessage, DrainAccessoriesKeys } from 'src/api';
import { DrainAccessoriesDefaultModel, DrainAccessoriesModel } from 'franke-trough-dependencies';
import { requestAPIActions } from 'loopback-react-request';

import MESSAGES from '../ConfigurationDetail.messages';

import 'rc-slider/assets/index.css';
import './ConfigurationDrain.page.scss';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationDrainsPageProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationDrains extends React.Component<ConfigurationDrainsPageProps, any> {
  componentDidMount() {
    // this.dispatchDefaults();
  }

  public render() {
    const fileName = this.props.configuration.result && this.props.configuration.result.selectedTrough && this.props.configuration.result.selectedTrough.trough.fileName;
    const isExos = this.props.configuration.result && this.props.configuration.result.selectedTrough && this.props.configuration.result.selectedTrough.trough.exos;
    
    return (
      <div className="page-configuration-drain">
        <div className="col-12">
          <ConfigurationHeader
            icon="drain-accessories"
            title={formatMessage(MESSAGES.drainTitle)}
          />
        </div>
        <div className="configuration-wrap pl-5 pr-5 pt-1">
          <div className="col-12 pb-3 pl-0 pr-0">
            <Accordion>
              {this.drainParts.map((props, index) => {
                  const key = `configuration_drain_${index}`;
                  return props ? (
                    <ConfigurationPart
                      key={key}
                      {...props}
                    />
                  ) : <React.Fragment key={key} />;
                })}
            </Accordion>
          </div>
           {((this.defaults && this.defaults.drain.values.length <= 1 ) || (fileName && fileName === 'VARIUSmed_MZB')) && (
            <div className="col-12 border-bottom pb-3 pl-0 mb-3">
            <small>
              <strong><FormattedMessage {...MESSAGES.note} /></strong><br />
              {this.defaults && this.defaults.drain.values.length <= 1 && (
                <><FormattedMessage {...MESSAGES.noteMessageNoOption} /><br /></>
              )}
              {fileName === 'VARIUSmed_MZB' && (
                <><FormattedMessage {...MESSAGES.noteMessageVARIUSmedMZB} /><br /></>
              )}
              {isExos && (
                <><FormattedMessage {...MESSAGES.noteMessageExos} /><br /></>
              )}
            </small>
          </div>
         )}
         
          <div className="col-12 pt-4 text-center">
            <div className="partial-element-next">
              <Link to={`checkout`} className="btn btn-secondary text-white">
                <FormattedMessage {...MESSAGES.drainBtnCompleteConfiguration} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get disabled(): boolean {
    return !isConfigurationEditable()
      || !this.props.configuration.result 
      || !this.props.configuration.result.drainAccessories;
  }

  private get defaults(): DrainAccessoriesDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.drainAccessories;
  }

  private get drainParts(): (ConfigurationPartProps | null)[] {
    const validated = this.props.validated.byItem.drainAccessories;
    return [{
      btnName: formatMessage(MESSAGES.drainTitle),
      component: DrainAccessories,
      error: [(validated && validated.drain) || (validated && validated.siphon) || false],
      id: DrainAccessoriesKeys.Drain,
    }];
  }
  
  private dispatchDefaults() {
    if (this.disabled) { return; }

    const configuration: any = this.props.configuration;
    const defaults = this.defaults;

    if (defaults) {
      const data: DrainAccessoriesModel | {} = {};
      Object.keys(defaults).map(key => {
        data[key] = defaults[key].default;
      });
      this.props.dispatch(requestAPIActions.load(
        'configuration',
        {
          url: `/Configurations/${configuration.result.id}`,
          options: {
            method: 'PATCH',
            data: {drainAccessories: data},
          },
        },
        true
      ));
    }
  }
}

export const ConfigurationDrainsPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration, 
  validated: state.validatedConfiguration,
}))(ConfigurationDrains);

export default ConfigurationDrainsPage;